import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../components/Breadcrumb";
import "../styles/HistorialPresupuestos.css";

export default function HistorialPresupuestos() {

    const { expediente } = useParams();
    const history = useHistory();

    const [presupuestos, setPresupuestos] = useState([]);
    const [paciente, setPaciente] = useState(null);
    const [loading, setLoading] = useState(true);
    const [presupuestoAbierto, setPresupuestoAbierto] = useState(null);

    useEffect(() => {

        async function cargarDatos() {

            try {

                const pacienteRes = await axios.get(`/api/pacientes/${expediente}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                });

                setPaciente(pacienteRes.data);

                const presupuestosRes = await axios.get(
                    `/api/presupuesto/paciente/${expediente}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`
                        }
                    }
                );

                setPresupuestos(presupuestosRes.data);

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }

        }

        cargarDatos();

    }, [expediente]);

    const descargarPresupuesto = async (id) => {
        try {
            const res = await axios.get(
                `/api/presupuesto/${id}/pdf`,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            const blob = new Blob([res.data], { type: "application/pdf" });
            window.open(URL.createObjectURL(blob), "_blank");

        } catch (err) {
            console.error("Error descargando presupuesto", err);
        }
    };

    const cambiarEstado = async (id) => {

        try {

            await axios.put(
                `/api/presupuesto/${id}/estado`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            setPresupuestos(prev =>
                prev.map(p =>
                    p.id === id
                        ? {
                            ...p,
                            estado:
                                p.estado === "ENTREGADO"
                                    ? "ACEPTADO"
                                    : p.estado === "ACEPTADO"
                                    ? "RECHAZADO"
                                    : p.estado === "RECHAZADO"
                                    ? "ERRONEO"
                                    : "ENTREGADO"
                        }
                        : p
                )
            );

        } catch (err) {
            console.error(err);
        }

    };

    if (loading) {
        return <p>Cargando...</p>;
    }

    return (

        <div className="historial-presupuestos-page">

            <Breadcrumb />

            <h2>
                Historial de presupuestos de{" "}
                {paciente
                    ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                          .filter(Boolean)
                          .join(" ")
                    : expediente}
            </h2>
            <table className="historial-table">
                <thead>
                    <tr>
                        <th>Nº Presupuesto</th>
                        <th>Fecha</th>
                        <th>Estado</th>
                        <th>Total</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {presupuestos.map(presupuesto => (
                        <React.Fragment key={presupuesto.id}>
                            <tr
                                className={`fila-presupuesto ${presupuestoAbierto === presupuesto.id ? "abierta" : ""}`}
                                onClick={() =>
                                    setPresupuestoAbierto(
                                        presupuestoAbierto === presupuesto.id
                                            ? null
                                            : presupuesto.id
                                    )
                                }
                            >
                                <td>{presupuesto.numero_presupuesto}</td>
                                <td>{presupuesto.fecha}</td>
                                <td>
                                    <button
                                        className={`estado-btn estado-${presupuesto.estado.toLowerCase()}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            cambiarEstado(presupuesto.id);
                                        }}
                                    >
                                        {presupuesto.estado}
                                    </button>
                                </td>
                                <td>{Number(presupuesto.total).toFixed(2)} €</td>
                                <td>
                                    <button
                                        className="btn-descargar"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            descargarPresupuesto(presupuesto.id);
                                        }}
                                    >
                                        PDF
                                    </button>
                                </td>
                            </tr>
                            {presupuestoAbierto === presupuesto.id && (
                                <tr className="fila-actuaciones">
                                    <td colSpan="4">
                                        <div className="detalle-actuaciones">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Tratamiento</th>
                                                        <th>Pieza</th>
                                                        <th>Cuadrante</th>
                                                        <th>Arcada</th>
                                                        <th>Cantidad</th>
                                                        <th>Importe</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {presupuesto.actuaciones.map((act, index) => (
                                                        <tr key={index}>
                                                            <td>{act.tratamiento}</td>
                                                            <td>{act.n_pieza}</td>
                                                            <td>{act.cuadrante}</td>
                                                            <td>{act.arcada}</td>
                                                            <td>{act.cantidad}</td>
                                                            <td>{Number(act.importe).toFixed(2)} €</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
            <div className="acciones-inferiores">
                <button
                    className="volver-btn"
                    onClick={() => history.goBack()}
                >
                    Volver
                </button>
            </div>
        </div>
    );
}